import PropTypes from 'prop-types'
import React from 'react'

import Ui from '../../../ui'
import ZentakeFormContext from '../ZentakeFormContext'

function ImageQuestion({ question }) {
  const formContext = React.useContext(ZentakeFormContext)

  const answer = formContext.getAnswer(question)
  const value = answer ? answer.answer_raw : null

  const isOfficeUse =
    ['office', 'read-only'].includes(formContext.mode) &&
    question.is_office_use_only

  return (
    <div>
      {question.text && (
        <Ui.QuestionTitle
          isOfficeUse={isOfficeUse}
          isRequired={question.is_required}
        >
          {question.text}
        </Ui.QuestionTitle>
      )}
      <div dangerouslySetInnerHTML={{ __html: value }} />
    </div>
  )
}

ImageQuestion.propTypes = {
  question: PropTypes.object.isRequired,
}

export default React.memo(ImageQuestion)
